import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the Marketing Campaigns API.
 *
 * This file drives:
 * - Enhanced API: computed endpoint keys in `enhanceEndpoints`
 * - Hook re-exports: clean name → generated name mapping
 * - MSW mock factories: HTTP method + URL path pattern
 */
export const MARKETING_CAMPAIGNS_API_ENDPOINTS = {
  createMarketingCampaign: {
    generated: 'marketingCampaignsAdminControllerCreateMarketingCampaignV1',
    method: 'post',
    path: '/api/v1/admin/marketing-campaigns',
  },
  listMarketingCampaigns: {
    generated: 'marketingCampaignsAdminControllerListMarketingCampaignsV1',
    method: 'get',
    path: '/api/v1/admin/marketing-campaigns',
  },
  listMarketingSources: {
    generated: 'marketingCampaignsAdminControllerListMarketingSourcesV1',
    method: 'get',
    path: '/api/v1/admin/marketing-campaigns/sources',
  },
  listMarketingMediums: {
    generated: 'marketingCampaignsAdminControllerListMarketingMediumsV1',
    method: 'get',
    path: '/api/v1/admin/marketing-campaigns/mediums',
  },
  getMarketingCampaign: {
    generated: 'marketingCampaignsAdminControllerGetMarketingCampaignV1',
    method: 'get',
    path: '/api/v1/admin/marketing-campaigns/:id',
  },
  updateMarketingCampaign: {
    generated: 'marketingCampaignsAdminControllerUpdateMarketingCampaignV1',
    method: 'put',
    path: '/api/v1/admin/marketing-campaigns/:id',
  },
  deleteMarketingCampaign: {
    generated: 'marketingCampaignsAdminControllerDeleteMarketingCampaignV1',
    method: 'delete',
    path: '/api/v1/admin/marketing-campaigns/:id',
  },
} as const satisfies Record<string, EndpointDef>;
